export default __webpack_public_path__ + "static/media/bgconq.352904d2.jpg";